const pencil = [
  "M13.3 4.52l-8.78 8.81-1.85-1.85 6.97-7 1.87 1.86.9-.91-1.86-1.87.9-.9zM4 14.12l-2.67.55.54-2.67zM0 16l4.75-.96L16 3.8 12.2 0 .96 11.25z"
];
export {
  pencil
};
//# sourceMappingURL=pencil.js.map
